window.toggleMenu=function (){
    var menu=document.querySelector("nav ul");
    if(menu.style.left == "0px"){
        menu.style.left = "-110%";
        document.querySelector("#anvorgesa img").src="./images/anvorgesa.svg"
    }else{
        menu.style.left = "0px";
        document.querySelector("#anvorgesa img").src="./images/anvorgesa_close.svg"
    }
}